import {React , useState , useEffect } from 'react'
import TextField from '@material-ui/core/TextField';
import { createMuiTheme , ThemeProvider} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import axios from 'axios';
import Cards from "../Content/Cards"
import "../Pages/Trending_sty.css"
import CustomPagination from "../components/CustomPagination"

const darkTheme = createMuiTheme({
  palette:{
  type : "dark",
  primary : {
    main : "#fff",
  },
  }
})

 

  const Search = () => {
  const [type, setType] = useState(0);
  const [page, setPage] = useState(1);
  const [SearchText, setSearchText] = useState("xxxxxxxxyyyyyyyyyzzzzzzz");
  const [Content, setContent] = useState();
  const [numOfPages, setnumOfPages] = useState();

  const fetchSearch = async ()=>{
      const { data } = await axios.get(`
      https://api.themoviedb.org/3/search/${type?'tv':'movie'}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&query=${SearchText}&page=${page}&include_adult=false
      `);

      setContent(data.results);
      setnumOfPages(data.total_pages);
  };
  useEffect(() => {
    window.scroll(0,0);
    fetchSearch();
    // eslint-disable-next-line
  }, [type,page])

  return (
    <>
    <ThemeProvider theme = {darkTheme}>
      <div style = {{display : "flex", margin : "10px 0"}}>
     <TextField
      style = {{flex : 1}}
      className  = "SearchBox"
      label = "Search"
      variant = "filled"
     onChange = {(e) => setSearchText(e.target.value)}
     />
     <Button variant = "contained" style = {{marginLeft : 10}} onClick = {fetchSearch}><SearchIcon/></Button>
     </div>
     <AppBar position="static" color="default">
     <Tabs
          value = {type}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
          onChange = {(event,newvalue)=>{
            setType(newvalue);
            setPage(1);
          }}
        >
          <Tab style = {{width : "50%"}} label="Search Movies"/>
          <Tab style = {{width : "50%"}} label="Search Tv series"/>
        </Tabs>
        </AppBar>
     </ThemeProvider>
     <div className = "Trend">{Content&&Content.map((val)=>{
       return(
       <Cards 
       key = {val.id} 
       id = {val.id} 
       poster = {val.poster_path} 
       title = {val.title || val.name} 
       date = {val.release_date || val.first_air_date}
       media_type = {type ? "tv":"movie"}
       vote_average = {val.vote_average}
       />
       )
       })}
       {SearchText&&!Content&&((type)?<h2 style = {{color : "white"}}>NO SERIES FOUND !</h2>:<h2 style = {{color : "white"}}>NO MOVIES FOUND !</h2>)}
       </div>
       {numOfPages>1&&<CustomPagination setPage = {setPage} numofPages = {numOfPages}/>}
    </>
  )
}

export default Search
